import api from "./api";

const transportService = {
    // Routes CRUD
    getRoutes: () => api.get("/transport/routes"),
    createRoute: (data) => api.post("/transport/routes", data),
    updateRoute: (id, data) => api.put(`/transport/routes/${id}`, data),
    deleteRoute: (id) => api.delete(`/transport/routes/${id}`),

    // Student Bus Allotment
    subscribe: (data) => api.post("/transport/subscribe", data),
    cancel: (id, data = {}) => api.put(`/transport/cancel/${id}`, data),
    collectFee: (id, data) => api.post(`/transport/collect-fee/${id}`, data),
    getPassengers: (params = {}) => api.get("/transport/passengers", { params }),
    getByStudent: (studentId) => api.get(`/transport/student/${studentId}`),
    getStudentHistory: (studentId) => api.get(`/transport/student/${studentId}`),
};

export default transportService;
